import { render, staticRenderFns } from "./SearchResultsCards.vue?vue&type=template&id=2c079d6b&scoped=true"
import script from "./SearchResultsCards.vue?vue&type=script&lang=js"
export * from "./SearchResultsCards.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsCards.vue?vue&type=style&index=0&id=2c079d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c079d6b",
  null
  
)

export default component.exports